var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    y: 0.613525,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6653 25.5935L14.6031 25.5175C13.2879 25.4911 11.9694 25.5439 10.6799 25.2698C8.71833 24.8603 8.57937 22.8524 8.43396 21.1681C8.23359 18.8003 8.31116 16.3895 8.68927 14.0414C8.90272 12.7239 9.74276 11.9377 11.0418 11.8522C15.4272 11.5417 19.8417 11.5785 24.2173 11.7233C24.6795 11.7366 25.1447 11.8092 25.6004 11.8918C27.8497 12.2947 27.9046 14.5701 28.0504 16.4856C28.1958 18.4208 28.1344 20.366 27.8565 22.288C27.6335 23.8794 27.2069 25.2139 25.4065 25.3428C23.1507 25.5112 20.9468 25.6469 18.6847 25.6037C18.6848 25.5935 18.6718 25.5935 18.6653 25.5935ZM16.2771 21.5645C17.977 20.5671 19.6445 19.5863 21.3347 18.5956C19.6316 17.5981 17.9673 16.6174 16.2771 15.6266V21.5645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeDark);
export default __webpack_public_path__ + "static/media/YoutubeDark.6c41f0c6e01007a7f86f20ddcb5b3f35.svg";
export { ForwardRef as ReactComponent };